import PopupLayout from 'components/PopupLayout';
import PopupUpdateUser from 'components/PopupUpdateUser';
import SocialAuth from 'components/SocialAuth';
import TermPolCheckbox from 'components/TermPolCheckbox';
import React, { useState } from 'react';
import PropTypes from 'prop-types';





const FormRegisterSocial= ({closeFormRegisterSocial=null}) => {


    const[termPolCheckedRegister,setTermPolCheckedRegister]=useState(true);
    const [selectedDocumentType, setSelectedDocumentType] = useState('');
    const [documentNumber, setDocumentNumber] = useState('');
    const [loginValidation, setLoginValidation] = useState(false);  // Nuevo estado para almacenar el valor de validate
    const [loginData,setLoginData]=useState();
    const [checkboxState, setCheckboxState] = useState({
        privacyPoliciesChecked: false,
       termConditionsChecked: false,
       legalOthersChecked:false,
        });

        const openPopupUpdateUser= () =>{
            //open popup band title end text de checkbox
       
      
            setLoginValidation(!loginValidation);
            console.log("validate login",loginValidation);
            closeFormRegisterSocial();

    
        }
        const handleLoginData = (loginDataUpdate) => {
            // Aquí puedes hacer lo que necesites con el payload en el componente padre
            console.log('Payload recibido en Register:', loginDataUpdate);
    
            // Puedes abrir el popup o hacer cualquier otra cosa con el payload
            setLoginData(loginDataUpdate);
        };
      
       const handleCheckboxClick = (isChecked,checkboxName) => {
        setCheckboxState(prevState => {
            const updatedState = {
                ...prevState,
                [checkboxName]: isChecked,
            };
           

            if (updatedState.privacyPoliciesChecked && updatedState.termConditionsChecked) {
                setTermPolCheckedRegister(false);


            } else {
                setTermPolCheckedRegister(true);

            }
    
            return updatedState;
        });
    
    };



    return (
        <div>
        <div className="form-group">
          <label className="label-select">Tipo de Documento</label>
          <select
            value={selectedDocumentType}
            onChange={(e) => setSelectedDocumentType(e.target.value)}
            disabled={false}
            className='custom-select'
           >
           <option value=""  >Seleccione...</option>
           <option value="1" >DNI</option>
           <option value="4" >Pasaporte</option>
           <option value="5" >RUC</option>
           <option value="2" >CI</option>
           <option value="3" >CE</option>
           <option value="9" >Sin-Doc-Id</option>
           <option value="0" >Otros</option>
           {/* Agrega más opciones según sea necesario */}
           </select>         
        </div>
        <div className="form-group">
         <label className="label-select">
                       N° Documento 
                   </label>
                   <input
                       value={documentNumber || ""}
                       onChange={(e) => setDocumentNumber(e.target.value) }
                       required
                       maxLength="50"
                       type="text"
                       className="form-control"
                       name="textBoxDocumento"
                       id="textBoxDocumento"
                       
                       placeholder="N° Documento"
           />
           <br/>
           
           <div className="col-12 ml-lg-auto mr-lg-auto mt-lg- mt-3">
           <TermPolCheckbox textId = "terminos"  onCheckboxClick={(isChecked) => handleCheckboxClick(isChecked, 'privacyPoliciesChecked')}
            value={checkboxState.privacyPoliciesChecked} setValue={(value) =>
            setCheckboxState({
            ...checkboxState,
            privacyPoliciesChecked: value,
            })
            } showToolip={true}/>
            </div>
            <div className="col-12 ml-lg-auto mr-lg-auto mt-lg- mt-3">
           <TermPolCheckbox textId = "politica"   onCheckboxClick={(isChecked) => handleCheckboxClick(isChecked, 'termConditionsChecked')} 
            value={checkboxState.termConditionsChecked} setValue={(value) =>
            setCheckboxState({
            ...checkboxState,
            termConditionsChecked: value,
            })} showToolip={true}/>
            </div>
            <div className="col-12 ml-lg-auto mr-lg-auto mt-lg- mt-3">
            <TermPolCheckbox textId = "legal-others"  onCheckboxClick={(isChecked) => handleCheckboxClick(isChecked, 'legalOthersChecked')}  value={checkboxState.legalOthersChecked} 
                setValue={(value) =>
                            setCheckboxState({
                                ...checkboxState,
                                legalOthersChecked: value,
                            })
                        }  />
           </div>
           <br/>
           <SocialAuth actionCall="register" disablebuttons={termPolCheckedRegister}  showFacebook={false} legal={checkboxState} 
                       documentInfo={{documentCode: selectedDocumentType,documentNumber: documentNumber, }} handleLoginValidation={setLoginValidation} handleLoginData={handleLoginData}/>

        </div>
        <PopupLayout isShowwing={loginValidation} showingCallback={openPopupUpdateUser}>
        <PopupUpdateUser execActionConfirm={openPopupUpdateUser} titleText={"Actualizacion de Datos"} popupLegalText={"update"} loginData={loginData}  />
        </PopupLayout>
       </div>
    );
};

FormRegisterSocial.propTypes = {
    closeFormRegisterSocial:PropTypes.func, 
};


export default FormRegisterSocial;
